import React, { useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { EMPTY_ARRAY, EMPTY_OBJECT, validPhone, getWalletScriptUrl, EVENT_TYPES } from '../../constants/globalConstants'
import CommonBtn from '../../components/global/CommonBtn'
import { Controller } from 'react-hook-form'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import { globalKeyStore } from '../../redux/actions/globalState'
import Loader from '../../components/global/Loader'
import { getSessionDetails, getDefaultSession, getCardDataList, getVehicleDataList, getVehicleModelList, dynamicPaymentGateByNonce } from '../../redux/actions/booking'
import { useEffect } from 'react'
import {
    emailRegEx, getPartnerDetails,
    isPermissionExist, isUserLoggedIn, restrictInputValues,
    restrictInValidCharLicense, restrictSpecialChar,
    sortPortalPermissionByKey, validExpiryDate, getDeviceType,
    showhideWalletButton,
    encryptionHandler, isTimeBeforeCurrentFacilityTime,
    formatYearMonthExpiry
} from '../../utils/helper'
import useNetwork from '../../services/NetworkDetector'
import { Circles } from 'react-loader-spinner'
import { Button } from 'react-bootstrap'
import debounce from 'lodash/debounce'
const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
const expirymask = createDefaultMaskGenerator('99/99')
import moment from 'moment'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { addScript } from '../../utils/addScript'
import WalletButtons from '../../components/walletButtons'
import URL from '../../constants/urls'
import CardConnectTokenizer from '../../components/walletButtons/CardTokenizer'
import { errorMessage } from '../../constants/errorMessage'

function PaymentBookingPage({
    dispatch,
    bookingFormDetail,
    errors,
    control,
    register,
    handleSubmit,
    getValues,
    bookingPromocode,
    sessionDetails,
    reset,
    userDetails,
    sessionError,
    sessionObj,
    selectEventType,
    eventandPassData,
    isLoading,
    setValue,
    isDirectBooking,
    nextFormStep,
    cardList,
    isCardFormVisible,
    isVehicleVisible,
    notify,
    payment_profile_id,
    vehicle_id,
    selectedFacilityId,
    fname,
    femail,
    fphone,
    fcard_pan,
    fcard_date_expiry_month,
    fcard_card_security_cvx_2,
    vehicleDetails,
    cardToken,
    setCardToken,
    iframeErrorMsg,
    setIframeErrorMsg,
    tokenRef,
}) {
    const [bookingShown, setbookingShown] = useState({ password: false, couponError: null })
    const [cardlidt, setCardList] = useState(false)
    const [vehicleList, setVehicleList] = useState(true)
    const [cardExpiryMessage, setCardExpiryMessage] = useState('')
    const [cardExpiry, setCardExpiry] = useState('')
    const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
    const [colorList, setColorList] = useState(EMPTY_ARRAY)
    const [stateList, setStateList] = useState(EMPTY_ARRAY)
    const [countryList, setCountryList] = useState(EMPTY_ARRAY)
    const [vehicleListArray, setVehicleListArray] = useState(EMPTY_ARRAY)
    const [makeModelObj, setMakeModelObj] = useState({
        color: '',
        country: '',
        license_plate: '',
        make: '',
        make_id: null,
        model: '',
        state_id: '',
        state_name: '',
        make_other: '',
        model_other: '',
        state_loader: false
    })
    const [accessPermissions, setAccessPermissions] = useState('')
    const [partnerData, setPartnerData] = useState(null)

    // vehicle type
    const [vehicleTypeData, setVehicleTypeData] = useState(EMPTY_ARRAY)
    // vehicle type end 

    const isOnline = useNetwork()
    const { pathname } = useLocation()
    const partnername = pathname?.split('/')?.filter(v => v != '')
    const navigate = useNavigate()
    const { independant_pass_id, facility } = useParams()


    const [verifyPrepay, setVerifyPrepay] = useState('1')
    const [walletDisable, setWalletDisable] = useState(false)
    const [isIOSDevice, setIsIOSdevice] = useState(false)
    const [checkInData, setCheckinData] = useState(EMPTY_OBJECT)
    const [isSubmittingForm, setIsSubmittingForm] = useState(false)
    const loaded = useRef()
    const applePaySessionRef = useRef(null)
    const [walletButtonShow, setWalletButtonShow] = useState(null)
    const [localIsBookingClosed, setLocalIsBookingClosed] = useState(false)

    useEffect(() => {
        const data = getPartnerDetails()
        setPartnerData(data)
        const deviceType = getDeviceType()
        setIsIOSdevice(deviceType)
        handleChangeDeb()
    }, []) // Run once on mount

    const handleChangeDeb = useCallback(debounce(() => {
        const facData = eventandPassData?.facilities?.filter((item) => {
            return item.id == selectedFacilityId
        })
        setCheckinData(facData?.length > 0 ? facData?.[0] : EMPTY_OBJECT)

        let facilityTimeZone = (facData?.length > 0 && facData?.[0]?.timezone) ? facData?.[0]?.timezone : 'America/New_York'
        let isBookingClosedCheck = isTimeBeforeCurrentFacilityTime(eventandPassData?.stop_event_booking_time, facilityTimeZone)
        setLocalIsBookingClosed(isBookingClosedCheck)
    }, 300), [])


    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerData?.customer_portal_permission, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerData])

    useEffect(() => {
        const localDataPaymentSession = localStorage.getItem('paymentSession') && localStorage.getItem('paymentSession') != undefined && localStorage.getItem('paymentSession') != 'undefined' ? JSON.parse(localStorage.getItem('paymentSession')) : {}
        if (localDataPaymentSession?.amount == 0) {
            dispatch(globalKeyStore({ isDirectBooking: true }))
        } else {
            dispatch(globalKeyStore({ isDirectBooking: false }))
        }
        getVehical()
        if (vehicleDetails.length > 0) {
            let selectedVehicle = vehicleDetails?.filter((item) => item?.is_default == '1')
            if (selectedVehicle?.length > 0) {
                dispatch(globalKeyStore({ vehicle_id: selectedVehicle[0]?.id }))
                setMakeModelObj({
                    color: '',
                    color_id: '',
                    country: '',
                    license_plate: selectedVehicle[0]?.license_plate_number,
                    make: '',
                    make_id: '',
                    model: '',
                    model_id: '',
                    state_id: '',
                    state_name: '',
                    make_other: '',
                    model_other: '',
                    state_loader: false
                })
                setVehicleList(false)
            }
        }
    }, EMPTY_ARRAY)

    useEffect(() => {
        reset(formValues => ({ ...formValues, email: userDetails?.email ? userDetails?.email : '', name: userDetails?.name ? userDetails?.name : '', phone: userDetails?.phone_number ? userDetails?.phone_number : '', }))
        const selLocalFacilityId = JSON.parse(localStorage?.getItem('selectedFacilityId'))
        if (selLocalFacilityId || selectedFacilityId) {
            const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
            dispatch(globalKeyStore({ selectedFacilityId: eventFacilityid }))

            if (eventFacilityid !== null) {
                if (isUserLoggedIn()) {
                    dispatch(getCardDataList()).then((res) => {
                        if (!res?.data?.payments?.length) {
                            notify('error', res?.errors?.message)
                        } else {
                            let selectedCard = res?.data?.payments?.filter((card) => card?.is_default == '1')
                            if (selectedCard?.length > 0) {
                                dispatch(globalKeyStore({ payment_profile_id: selectedCard[0]?.payment_profile_id, selectedCard: selectedCard[0] }))
                            }
                        }
                    }).catch((err) => {
                        notify('error', err?.message)
                    })
                    dispatch(getVehicleDataList()).then(() => {
                        // console.log(res, 'vehicle response')
                    }).catch((err) => {
                        notify('error', err?.message)
                    })
                }
            }
        }

        setTimeout(() => {
            dispatch(globalKeyStore({ ExpiryTimeSession: 0 }))
        }, 900000)

    }, [userDetails, isUserLoggedIn()])


    const handlCardExpiry = (value) => {
        let expiryDateCheck = validExpiryDate(value)
        if (value.length == 4 && !expiryDateCheck) {
            setCardExpiryMessage('Enter a valid expire date')
        } else {
            setCardExpiryMessage('')
            setCardExpiry(value?.trim())
            setValue('card_date_expiry_month', value.substring(0, 2))
            setValue('card_date_expiry_year', value.substring(2))
            setValue('expiration_date', value)
        }

    }


    // for coupon perpose 
    const applyCoupon = () => {
        let data = getValues()
        const { name, email, phone } = data
        let validEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(data.email)
        if (!data.coupon) {
            setbookingShown({ ...bookingShown, couponError: 'Please enter a Promocode' })
        } else if (
            !data.name ||
            !validEmail ||
            !data.phone
        ) {
            setbookingShown({ ...bookingShown, couponError: 'Please enter valid user details' })
        } else {
            setbookingShown({ ...bookingShown, couponError: null })
            let sessionPayload = JSON.parse(JSON.stringify(sessionObj))
            sessionPayload.promocode = data.coupon
            sessionPayload.email = data.email
            sessionPayload.promo = data.email
            sessionPayload.license_plate = makeModelObj.license_plate ? makeModelObj.license_plate : ''
            sessionPayload.phone = data.phone
            if (!isUserLoggedIn()) {
                sessionPayload.is_guest = '1'
            }
            if (independant_pass_id) {
                sessionPayload.rate_id = independant_pass_id
            }
            dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false } }))
            const get_event_type = selectEventType == 'event' ? selectEventType : selectEventType == 'pass' ? localStorage.getItem('pass_type_slug') : ''
            const event_data = eventandPassData
            dispatch(getSessionDetails(sessionPayload)).then((res) => {
                setVerifyPrepay(walletButtonShow ? '1' : '0')
                if (res.data) {
                    const updatedDetails = {
                        ...bookingFormDetail,
                        vehicle_details: { ...makeModelObj, vehicle_id: vehicle_id },
                        personal_info: { name, email, phone },
                        payment_detail: null,
                        get_event_type: get_event_type,
                        event_data: event_data,
                        sessionDetails: res?.data
                    }
                    localStorage.setItem('bookingFormDetail', JSON.stringify(updatedDetails))
                    dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, data: res.data, coupon_code: data.coupon, promocode: true }, 'sessionError': null }))
                    if (res?.data?.amount == 0) {
                        dispatch(globalKeyStore({ isDirectBooking: true }))
                    } else {
                        dispatch(globalKeyStore({ isDirectBooking: false }))
                    }
                    localStorage.setItem('promo_applied', 1)
                } else {
                    let curObj = {}
                    if (independant_pass_id) {
                        curObj.rate_id = independant_pass_id
                    }
                    dispatch(globalKeyStore({ 'sessionError': res?.errors }))
                    localStorage.setItem('couponApplied', 'Yes, but ' + res?.errors?.message)
                    setValue('coupon', '')
                    dispatch(getDefaultSession({ ...sessionObj, ...curObj })).then((res) => {
                        dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, data: res.data, promocode: false, coupon_code: null } }))
                    }).catch((err) => {
                        console.log(err)
                    })
                }
            }).catch((err) => {
                setVerifyPrepay(walletButtonShow ? '1' : '0')
                console.log(err)
            })
            setbookingShown({ ...bookingShown, couponError: null })
        }
    }

    useEffect(() => {
        if (sessionDetails?.promocode && !sessionError) {
            handleCouponRemove()
        }
    }, [fname, femail, fphone])

    useEffect(() => {
        if (sessionDetails?.promocode && !sessionError) {
            dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false } }))
        }
    }, [fcard_pan, fcard_date_expiry_month, fcard_card_security_cvx_2])

    useEffect(() => {
        // Load Wallet Payment Script
        const paymentGateway = (checkInData?.facility_payment_details?.facility_payment_type_id || eventandPassData?.facility?.facility_payment_details?.facility_payment_type_id)
        const applePayScript = getWalletScriptUrl(paymentGateway)
        Object.values(applePayScript)?.map((item) => {
            if (item) {
                addScript(loaded, item, '')
            }
        })
        const getWalletPermission = isPermissionExist(accessPermissions, 'Enable A/G Pay - Event')
        setWalletButtonShow(showhideWalletButton(checkInData?.facility_payment_details?.facility_payment_type_id ? checkInData : eventandPassData?.facility?.facility_payment_details?.facility_payment_type_id ? eventandPassData?.facility : {}) && getWalletPermission)
        // Load Wallet Payment Script
    }, [EMPTY_ARRAY, accessPermissions, (checkInData?.facility_payment_details?.facility_payment_type_id || eventandPassData?.facility?.facility_payment_details?.facility_payment_type_id)])
    useEffect(() => {
        setVerifyPrepay(walletButtonShow ? '1' : '0')
    }, [getValues()?.name, getValues()?.email, getValues()?.phone, getValues()?.vehicle_type, getValues()?.license_plate])

    const closeApplePaySession = (endsession) => {
        if (applePaySessionRef.current) {
            if (endsession === 'success') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_SUCCESS)
            } else if (endsession === 'failed') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_FAILURE)
            } else {
                applePaySessionRef.current.abort()
            }
        }
    }


    const onClickSubmit = (finalData = {}, prepay = '') => {
        // const bookingData = bookingFormDetail
        const get_event_type = selectEventType == 'event' ? selectEventType : selectEventType == 'pass' ? localStorage.getItem('pass_type_slug') : ''
        const event_data = eventandPassData
        // const bookingData = JSON.parse(localStorage.getItem('bookingFormDetail')) ? JSON.parse(localStorage.getItem('bookingFormDetail')) : '{}'
        const bookingData = JSON.parse(localStorage.getItem('bookingFormDetail')) ? JSON.parse(localStorage.getItem('bookingFormDetail')) : {}
        // const userDataLoc = JSON.parse(localStorage.getItem('userData'))
        const { payment_detail, sessionDetails, user_consent, payment_profile_id, vehicle_details } = (bookingData) ? bookingData : EMPTY_OBJECT
        const { name, email, phone } = getValues()
        const { card_pan, card_date_expiry_month, card_date_expiry_year, card_card_security_cvx_2 } = (payment_detail) ? payment_detail : EMPTY_OBJECT
        const eventTypeLoc = localStorage.getItem('selectEventType')
        
        let encryptCardData = ''
        
        if((selectEventType == 'event' && checkInData?.facility_payment_details?.facility_payment_type_id != '3') && (selectEventType == 'pass' && eventandPassData?.facility?.facility_payment_details?.facility_payment_type_id != '3')){
            let card = {
                name_on_card: name ? name : '',
                card_number: cardToken?.token || '',
                expiration_date: formatYearMonthExpiry(cardToken?.expiry),
                security_code: '',
            }
            if (cardToken?.zip_code) {
                card.zip_code = cardToken?.zip_code
            }
            encryptCardData = encryptionHandler(card)
        }else{
            const encryptedPayload = {
                name_on_card: (name) ? name : '',
                card_number: (card_pan) ? card_pan : '',
                expiration_date: `${(card_date_expiry_month) ? card_date_expiry_month : ''}${(card_date_expiry_year) ? card_date_expiry_year : ''}`,
                // Above change has a BE Dependancy, Ask Ujjwal sir
                security_code: (card_card_security_cvx_2) ? card_card_security_cvx_2 : '',
                zip_code: ''
            }
            if (encryptedPayload?.expiration_date == '' && encryptedPayload?.card_number == '') {
                encryptCardData = ''
            } else if ((encryptedPayload?.expiration_date && encryptedPayload?.card_number)) {
                encryptCardData = encryptionHandler(encryptedPayload)
            }
        }

        const selLocalFacilityId = JSON.parse(localStorage?.getItem('selectedFacilityId'))

        if (selLocalFacilityId || selectedFacilityId) {
            const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
            dispatch(globalKeyStore({ selectedFacilityId: eventFacilityid }))

            let finalPayload = {}

            if (get_event_type !== EVENT_TYPES?.EVENT && eventTypeLoc == 'pass') {
                let passEventIds
                if (event_data?.is_full_season == 0) {
                    passEventIds = JSON.parse(localStorage.getItem('userChooseEvents'))
                    // console.log(passEventIds, 'passEventIds')
                } else {
                    passEventIds = event_data?.all_event?.map((item) => item?.id)
                }
                finalPayload = {
                    'facility_id': eventFacilityid,
                    'name': name,
                    'phone': phone,
                    'email': email,
                    'total': sessionDetails?.data?.amount,
                    'rate_id': get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
                    'event_id': '',
                    'event_category_id': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.event_category_event?.event_category_id : event_data?.event_category_id,
                    'arrival': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.start_time : event_data?.all_event[0]?.start_time,
                    'event_type': get_event_type,
                    'is_full_season': (get_event_type != EVENT_TYPES?.EVENT) ? event_data?.is_full_season : '',
                    'reference': sessionDetails?.data?.reference,
                    'ex_month': card_date_expiry_month,
                    'ex_year': card_date_expiry_year,
                    'user_consent': (user_consent) ? user_consent : '0',
                    'event_ids': passEventIds,
                    'is_booking_direct': (payment_detail) ? '0' : '1',
                    'promocode': (sessionDetails?.coupon_code) ? sessionDetails?.coupon_code : '',
                    'user_id': (isUserLoggedIn()) ? userDetails?.id : ''
                }
            } else {
                finalPayload = {
                    'facility_id': eventFacilityid,
                    'name': name,
                    'phone': phone,
                    'email': email,
                    'total': sessionDetails?.data?.amount,
                    'rate_id': get_event_type == EVENT_TYPES?.EVENT ? '' : event_data?.id,
                    'event_id': get_event_type == EVENT_TYPES?.EVENT ? event_data?.id : '',
                    'arrival': (get_event_type == EVENT_TYPES?.EVENT) ? event_data?.start_time : event_data?.all_event[0]?.start_time,
                    'event_type': get_event_type,
                    'is_full_season': (get_event_type != EVENT_TYPES?.EVENT) ? event_data?.is_full_season : '',
                    'user_consent': (user_consent) ? user_consent : '0',
                    'is_booking_direct': (payment_detail) ? '0' : '1',
                    'promocode': (sessionDetails?.coupon_code) ? sessionDetails?.coupon_code : '',
                    'user_id': (isUserLoggedIn()) ? userDetails?.id : ''
                }
            }
            if (vehicle_details?.vehicle_id && vehicle_details?.license_plate) {
                finalPayload.vehicle_id = vehicle_details?.vehicle_id
                finalPayload.license_plate = vehicle_details?.license_plate
            } else if (vehicle_details?.license_plate && !vehicle_details?.vehicle_id) {
                finalPayload.license_plate = vehicle_details?.license_plate
                finalPayload.color = vehicle_details?.color
                finalPayload.make = vehicle_details?.make_id ? '' : (vehicle_details?.make == 'Others' ? vehicle_details?.make_other : vehicle_details?.make)
                finalPayload.model = vehicle_details?.model_id ? '' : ((vehicle_details?.make == 'Others' || vehicle_details?.model == 'Others') ? vehicle_details?.model_other : vehicle_details?.model)
                finalPayload.country = vehicle_details?.country
                finalPayload.state_id = vehicle_details?.state_id
                finalPayload.color_id = vehicle_details?.color_id
                finalPayload.make_id = vehicle_details?.make_id
                finalPayload.model_id = vehicle_details?.model_id
                finalPayload.vehicle_type_id = vehicle_details?.vehicle_type_id
                finalPayload.vehicle_type = vehicle_details?.vehicle_type
            } else if (makeModelObj) {
                finalPayload.license_plate = makeModelObj?.license_plate
                finalPayload.color = makeModelObj?.color
                finalPayload.make = makeModelObj?.make_id ? '' : (makeModelObj?.make == 'Others' ? makeModelObj?.make_other : makeModelObj?.make)
                finalPayload.model = makeModelObj?.model_id ? '' : ((makeModelObj?.make == 'Others' || makeModelObj?.model == 'Others') ? makeModelObj?.model_other : makeModelObj?.model)
                finalPayload.country = makeModelObj?.country
                finalPayload.state_id = makeModelObj?.state_id
                finalPayload.color_id = makeModelObj?.color_id
                finalPayload.make_id = makeModelObj?.make_id
                finalPayload.model_id = makeModelObj?.model_id
                finalPayload.vehicle_type_id = makeModelObj?.vehicle_type_id
                finalPayload.vehicle_type = makeModelObj?.vehicle_type
            }
            if (sessionDetails?.data?.discounted_amount > 0) {
                finalPayload.discount = sessionDetails?.data?.discounted_amount
            }
            if (prepay != 'post') {
                if (finalData?.paymentMethods) {
                    finalPayload.paymentMethods = finalData?.paymentMethods
                    finalPayload.walletPay = finalData?.walletPay
                    finalPayload.verify_prepay = (prepay == 'post' || verifyPrepay == '1') ? '1' : '0'
                } else {
                    finalPayload.payment_profile_id = (payment_profile_id) ? payment_profile_id : ''
                    finalPayload.nonce = encryptCardData
                }
            } else {
                finalPayload.verify_prepay = verifyPrepay == '1' ? '1' : '0'
            }

            setWalletDisable(true)
            dispatch(dynamicPaymentGateByNonce(finalPayload)).then((res) => {
                setWalletDisable(false)
                if (res?.data) {
                    if (prepay == 'post') {
                        setVerifyPrepay('0')
                    } else {
                        closeApplePaySession('success')
                        if (facility) {
                            navigate(`/${partnername?.[0]}/${facility}/${URL?.PAYMENT_SUCCESS1}`)
                        } else if (URL?.PAYMENT_SUCCESS1) {
                            navigate(`/${partnername?.[0]}/${URL?.PAYMENT_SUCCESS1}`)
                        } else {
                            navigate(`/${partnername?.[0]}`)
                        }
                        localStorage.setItem('paymentResponse', JSON.stringify(res?.data))
                    }
                } else {
                    if (prepay == 'post') {
                        setVerifyPrepay(walletButtonShow ? '1' : '0')
                    } else {
                        closeApplePaySession('failed')
                        if (facility) {
                            navigate(`/${partnername?.[0]}/${facility}/${URL?.PAYMENT_FAIL2}`)
                        } else if (URL?.PAYMENT_SUCCESS1) {
                            navigate(`/${partnername?.[0]}/${URL?.PAYMENT_FAIL2}`)
                        } else {
                            navigate(`/${partnername?.[0]}`)
                        }

                        localStorage.setItem('paymentResponse', JSON.stringify(res))
                    }
                }
            }).catch(() => {
                if (prepay == 'post') {
                    setVerifyPrepay(walletButtonShow ? '1' : '0')
                } else {
                    setWalletDisable(false)
                    closeApplePaySession('failed')
                    navigate(`/${partnername?.[0]}`)
                }
            })
        }
    }

    const handleCouponRemove = () => {
        setWalletDisable(true)
        let curObj = {}
        if (independant_pass_id) {
            curObj.rate_id = independant_pass_id
        }
        dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false, ...curObj } }))
        dispatch(getDefaultSession({ ...sessionObj, ...curObj })).then((res) => {
            setVerifyPrepay(walletButtonShow ? '1' : '0')
            dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, data: res.data, promocode: false, coupon_code: null } }))
            setValue('coupon', '')
            dispatch(globalKeyStore({ isDirectBooking: false }))
            localStorage.setItem('promo_applied', '')
            localStorage.setItem('coupon', '')
            localStorage.setItem('couponApplied', 'Yes, but removed')
            setWalletDisable(false)
        }).catch((err) => {
            setVerifyPrepay(walletButtonShow ? '1' : '0')
            setWalletDisable(false)
            console.log(err)
        })
    }
    const handleCoupon = (e) => {
        localStorage.setItem('coupon', e.target.value)
        if (sessionDetails?.promocode && !sessionError) {
            handleCouponRemove()
        }
    }

    // new function and for next step
    const handleNextStep = (data) => {
        const { name, email, phone, card_pan, card_card_security_cvx_2, card_date_expiry_month, card_date_expiry_year, zipcode } = data
        if (isOnline) {
            // let curDate = new Date()
            // let thisMonth = new Date().getMonth() + 1
            // let thisYear = new Date().getFullYear()
            // let thisMonthYear = moment(thisMonth + '-01-' + thisYear).format('MM-DD-YYYY')
            // let cardMonthYear = moment(card_date_expiry_month + '-01-20' + card_date_expiry_year).format('MM-DD-YYYY')
            const currentDate = new Date(moment(new Date()).format('YYYY'), moment(new Date()).format('MM') - 1)
            const cardExpiry = new Date(moment(card_date_expiry_year, 'YY').format('YYYY'), card_date_expiry_month - 1)
            let checkDate = cardExpiry >= currentDate || isDirectBooking || payment_profile_id || (!iframeErrorMsg || iframeErrorMsg == '')

            setCardList(true)
            setVehicleList(true)
            let checkMakeModel = false
            if (makeModelObj?.make == 'Others') {
                checkMakeModel = vehicleMakeList?.some((value) => value.name.toLowerCase() == makeModelObj?.make_other.toLowerCase())
                if (checkMakeModel) {
                    notify('error', 'You can not add duplicate make.')
                }
            } else if (makeModelObj?.make != 'Others' && makeModelObj?.model == 'Others') {
                let makeList = vehicleMakeList?.filter((v) => v.name == makeModelObj?.make)
                if (makeList.length > 0) {
                    checkMakeModel = makeList[0]?.mst_model?.some((model) => model.name.toLowerCase() == makeModelObj?.model_other.toLowerCase())
                    if (checkMakeModel) {
                        notify('error', 'You can not add duplicate model.')
                    }
                }
            }

            let facilityTimeZone = checkInData?.timezone ? checkInData?.timezone : 'America/New_York'
            let isBookingClosedCheck = isTimeBeforeCurrentFacilityTime(eventandPassData?.stop_event_booking_time, facilityTimeZone)
            // console.log('isBookingClosedCheck', isBookingClosedCheck)
            if (isBookingClosedCheck) {
                setLocalIsBookingClosed(isBookingClosedCheck)
                notify('error', 'Sorry, this event is now Sold Out due to time constraints.')
            } else if (checkMakeModel) {
                return false
            } else if (
                (name != '' && name != null && email != '' && email != null && 
                    ((card_pan != '' && card_pan != null && 
                    (card_pan?.length >= 14 || card_pan?.length <= 16)
                    && card_card_security_cvx_2 != '' && 
                    card_card_security_cvx_2 != null && 
                    (card_card_security_cvx_2?.length == 3 || card_card_security_cvx_2?.length == 4) && 
                    card_date_expiry_month != '' && card_date_expiry_month != null && 
                    card_date_expiry_year != '' && card_date_expiry_year != null) || (cardToken && cardToken?.token)) && 
                    phone != '' && phone != null) ||
                isDirectBooking ||
                (payment_profile_id && verifyPrepay != '1')
            ) {
                const get_event_type = selectEventType == 'event' ? selectEventType : selectEventType == 'pass' ? localStorage.getItem('pass_type_slug') : ''
                const event_data = eventandPassData
                const updatedDetails = {
                    ...bookingFormDetail,
                    vehicle_details: { ...makeModelObj, vehicle_id: vehicle_id },
                    personal_info: { name, email, phone },
                    payment_detail: (isDirectBooking) ? null : { card_pan, card_card_security_cvx_2, card_date_expiry_month, card_date_expiry_year, zipcode },
                    get_event_type: get_event_type,
                    event_data: event_data,
                    sessionDetails: sessionDetails,
                    user_consent: (data?.user_consent) ? '1' : '0',
                    payment_profile_id: payment_profile_id
                }
                setCardList(false)
                setVehicleList(false)
                localStorage.setItem('bookingFormDetail', JSON.stringify(updatedDetails))
                if (sessionDetails?.data?.amount == 0) {
                    nextFormStep()
                } else if (checkDate) {
                    nextFormStep()
                }else{
                    notify('error', iframeErrorMsg && iframeErrorMsg != '' ? iframeErrorMsg : errorMessage?.somethingWentWrong)
                }
            } else if ((name != '' && name != null && email != '' && email != null && phone != '' && phone != null) && walletButtonShow && verifyPrepay == '1') {
                const get_event_type = selectEventType == 'event' ? selectEventType : selectEventType == 'pass' ? localStorage.getItem('pass_type_slug') : ''
                const event_data = eventandPassData
                const updatedDetails = {
                    ...bookingFormDetail,
                    vehicle_details: { ...makeModelObj, vehicle_id: vehicle_id },
                    personal_info: { name, email, phone },
                    payment_detail: (isDirectBooking) ? null : { card_pan, card_card_security_cvx_2, card_date_expiry_month, card_date_expiry_year, zipcode },
                    get_event_type: get_event_type,
                    event_data: event_data,
                    sessionDetails: sessionDetails,
                    user_consent: (data?.user_consent) ? '1' : '0',
                    payment_profile_id: payment_profile_id
                }
                localStorage.setItem('bookingFormDetail', JSON.stringify(updatedDetails))
                onClickSubmit({}, 'post')
            }
        }
    }

    const showCardForm = () => {
        dispatch(globalKeyStore({ isCardFormVisible: true, payment_profile_id: '' }))
        setCardList(false)
    }

    const hideCardForm = () => {
        dispatch(globalKeyStore({ isCardFormVisible: false, payment_profile_id: '' }))
        setCardList(false)
    }

    const showVehicleForm = () => {
        dispatch(globalKeyStore({ isVehicleVisible: true, vehicle_id: '' }))
        setMakeModelObj({
            color: '',
            color_id: '',
            country: '',
            license_plate: '',
            make: '',
            make_id: '',
            model: '',
            model_id: '',
            state_id: '',
            state_name: '',
            make_other: '',
            model_other: '',
            state_loader: false
        })
        setVehicleList(false)
    }

    const hideVehicleForm = () => {
        dispatch(globalKeyStore({ isVehicleVisible: false, vehicle_id: '' }))
        setMakeModelObj({
            color: '',
            color_id: '',
            country: '',
            license_plate: '',
            make: '',
            make_id: '',
            model: '',
            model_id: '',
            state_id: '',
            state_name: '',
            make_other: '',
            model_other: '',
            state_loader: false
        })
        setVehicleList(true)
    }

    const handleCardSelectChange = (e) => {
        const { value } = e.target
        if (value) {
            let selectedCard = cardList?.filter((card) => card?.payment_profile_id == value)
            dispatch(globalKeyStore({ payment_profile_id: selectedCard[0]?.payment_profile_id, selectedCard: selectedCard[0] }))
        } else {
            dispatch(globalKeyStore({ payment_profile_id: '', selectedCard: {} }))
        }
        if (sessionDetails?.promocode && !sessionError) {
            dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false } }))
        }

    }

    const handleVehicleSelectChange = (e) => {
        const { value, name } = e.target
        if (value) {
            let selectedVehicle = vehicleDetails?.filter((item) => item?.id == value)
            dispatch(globalKeyStore({ vehicle_id: selectedVehicle[0]?.id }))
            setMakeModelObj({
                color: '',
                color_id: '',
                country: '',
                license_plate: selectedVehicle[0]?.license_plate_number,
                make: '',
                make_id: '',
                model: '',
                model_id: '',
                state_id: '',
                state_name: '',
                make_other: '',
                model_other: '',
                state_loader: false
            })
            setVehicleList(false)
        } else {
            dispatch(globalKeyStore({ vehicle_id: '' }))
        }
        if (sessionDetails?.promocode && !sessionError) {
            dispatch(globalKeyStore({ 'sessionDetails': { ...sessionDetails, promocode: false } }))
        }
        if (name === 'vehicle_saved_id' && sessionDetails?.promocode && !sessionError) {
            handleCouponRemove()
        }
    }

    const handleInputChange = (e) => {
        handleChangeDeb()
        const { name } = e.target
        if (localStorage.getItem('promo_applied') == 1) {
            handleCouponRemove()
        }
        if ((name == 'email' && sessionDetails?.promocode && !sessionError) || (name == 'phone' && sessionDetails?.promocode && !sessionError)) {
            handleCouponRemove()
        }
    }

    const getVehical = () => {

        dispatch(getVehicleModelList()).then((res) => {
            setColorList(res.color)
            setStateList(res.state)
            setCountryList(res.country)
            // vehicle type
            setVehicleTypeData(res?.vehicletype)
            // vehicle type end
            let makeList = JSON.parse(JSON.stringify(res.make))
            makeList?.unshift({
                'id': 'Others',
                'name': 'Others',
                'mst_model': [{
                    'id': 'Others',
                    'make_id': 'Others',
                    'name': 'Others'
                }]
            })

            setVehicleMakeList(makeList)

        })

    }

    const handleInputFieldsData = (e) => {
        const { name, value } = e.target
        if (name === 'make' && value) {
            let modList = JSON.parse(JSON.stringify(vehicleMakeList))
            let filtermodelList = modList?.filter((item) => item.id == value)
            let modelList = filtermodelList.length > 0 ? filtermodelList[0].mst_model : []
            reset(formValues => ({ ...formValues, model: '', model_id: '', make_other: '', model_other: '' }))
            if (value !== 'Others') {
                let check = modelList?.some((value) => value?.name == 'Others')
                if (!check) {
                    // If 'Others' is not in the list, add it to the first position
                    modelList.unshift({
                        'id': 'Others',
                        'make_id': 'Others',
                        'name': 'Others'
                    })
                } else {
                    // If 'Others' exists, find and move it to the first index
                    modelList = modelList.filter((value) => value?.name !== 'Others') // Remove 'Others' from the list
                    modelList.unshift({
                        'id': 'Others',
                        'make_id': 'Others',
                        'name': 'Others'
                    }) // Add it back at the first index
                }
                setMakeModelObj({
                    ...makeModelObj,
                    make_id: Number(value),
                    make: filtermodelList.length > 0 ? filtermodelList[0].name : 'Others',
                    model: '',
                    model_id: '',
                    make_other: '',
                    model_other: ''
                })
            } else if (value === 'Others') {
                setMakeModelObj({
                    ...makeModelObj,
                    make_id: '',
                    make: value,
                    model: value,
                    model_id: '',
                    make_other: '',
                    model_other: ''
                })
            } else {
                setMakeModelObj({
                    ...makeModelObj,
                    make_id: '',
                    make: '',
                    model: '',
                    model_id: '',
                    make_other: '',
                    model_other: ''
                })
            }
            setVehicleListArray(modelList)
        } else if (name === 'model' && value) {
            let modelData = vehicleListArray?.filter((v) => v.name == value)
            reset(formValues => ({ ...formValues, model_other: '' }))
            setMakeModelObj({
                ...makeModelObj,
                model: value,
                model_id: modelData?.[0]?.id != 'Others' ? modelData?.[0]?.id : '',
                model_other: ''
            })
        } else if (name === 'country') {
            setMakeModelObj({
                ...makeModelObj,
                [name]: value,
                state_loader: true,
                state_id: ''
            })
            let countryListState = JSON.parse(JSON.stringify(countryList))
            let countryCode = countryListState.filter((item) => {
                return item.country_code === value
            })
            dispatch(getVehicleModelList('', value === '' ? '' : countryCode[0]?.id)).then((res) => {
                setStateList(res.state)
                setMakeModelObj({
                    ...makeModelObj,
                    [name]: value,
                    state_loader: false
                })
            }).catch(() => {
                setMakeModelObj({
                    ...makeModelObj,
                    [name]: value,
                    state_loader: false
                })
            })
        } else if (name === 'make' && !value) {
            setMakeModelObj({
                ...makeModelObj,
                make_id: '',
                make: '',
                model: '',
                model_id: '',
                make_other: '',
                model_other: ''
            })
        } else if (name == 'vehicle_type') {
            let getvehicletypeId = vehicleTypeData?.filter((v) => v?.name === value)
            setVerifyPrepay(walletButtonShow ? '1' : '0')
            setMakeModelObj({
                ...makeModelObj,
                [name]: value,
                vehicle_type_id: getvehicletypeId[0]?.id ? getvehicletypeId[0]?.id : '',
            })
        } else if (name == 'color') {
            let colorData = colorList?.filter((v) => v.name == value)
            setMakeModelObj({
                ...makeModelObj,
                [name]: value,
                color_id: colorData[0]?.id ? colorData[0]?.id : '',
            })
        } else {
            if (name === 'license_plate') {
                setVerifyPrepay(walletButtonShow ? '1' : '0')
                setMakeModelObj({ ...makeModelObj, [name]: restrictInValidCharLicense(value) })
            } else {
                setMakeModelObj({ ...makeModelObj, [name]: value })
            }
        }
        if (name === 'license_plate' && sessionDetails?.promocode && !sessionError) {
            handleCouponRemove()
        }
    }

    const limitEnabled = isPermissionExist(accessPermissions, 'Enable Vehicle Limit')
    const maxVehicle = partnerData?.max_vehicle
    const vehicleCount = vehicleDetails?.length || 0

    // Final condition
    const canAddVehicle = !limitEnabled || (maxVehicle === 0 || maxVehicle > vehicleCount)
    return (

        <form autoComplete='off'>
            {/* action={sessionDetails?.data?.api_url} className="border p-4" target="_top" name="ipg_form" method="post" */}

            <div className="w-full mb-3 ">
                <div className="d-flex"><label className="mb-3 h5"><b>Personal Information</b></label></div>
                <div className="row row-cols-1 row-cols-sm-3 g-2">
                    <div className="col">
                        <label className="mb-1"><b>Name <span style={{ color: 'red' }}>*</span></b></label>
                        <input type="text" className="form-control" onChange={() => handleInputChange()} disabled={isUserLoggedIn() ? true : false} name='name' id="name" placeholder="Name" {...register('name', { required: true })} />
                        {errors?.name?.type === 'required' && <span className="form-text text-danger h-40">This field is required</span>}
                    </div>
                    <div className="col">
                        <label className="mb-1"><b>Email Address <span style={{ color: 'red' }}>*</span></b></label>
                        <input type="email" name='email' disabled={isUserLoggedIn() ? true : false} onChange={() => handleInputChange()} className="form-control" maxLength='40' minLength='1' placeholder="Email Address"
                            {...register('email', {
                                required: true,
                                pattern: { value: emailRegEx, message: 'invalid email address' }
                            })}
                        />
                        {errors?.email && <>
                            {errors.email.type === 'required' && <span className="form-text text-danger h-40">This field is required</span>}
                            {errors.email.type === 'pattern' && <span className="form-text text-danger h-40">{errors?.email?.message}</span>}
                        </>}
                    </div>
                    <div className="col">
                        <label className="mb-1"><b>Phone Number <span style={{ color: 'red' }}>*</span></b></label>
                        <Controller
                            name="phone"
                            type="text"
                            id="phone"
                            control={control}
                            rules={{
                                required: {
                                    value: true,
                                    message: 'This field is required',
                                },
                                pattern: {
                                    value: validPhone,
                                    message: 'Please enter a valid phone number',
                                },
                            }}
                            onChange={() => handleInputChange()}
                            render={({ field }) => <MaskedInput
                                maskGenerator={phoneMaskGenerator}
                                className="form-control"
                                {...field}
                                maxLength={14}
                                minLength={10}
                                title="Please enter a valid phone number"
                                onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                onInput={e => e.target.setCustomValidity('')}
                                placeholder="Phone Number"
                                disabled={(isUserLoggedIn() && userDetails?.phone_number) ? true : false}
                            />}
                        />
                        {errors?.phone?.type === 'required' && <span className="form-text text-danger h-40">This field is required</span>}
                        {errors?.phone?.type === 'pattern' && <span className="form-text text-danger h-40">Please enter a valid phone number</span>}
                    </div>
                </div>

            </div>
            <hr />

            <div className="w-full mb-3">
                <label className={`${!isUserLoggedIn() ? 'h5' : ''} mb-2`}><b>Vehicle Details {(isUserLoggedIn() && !isVehicleVisible) && <span style={{ color: 'red' }}>*</span>}</b></label>
                {(isUserLoggedIn() && (vehicleDetails.length > 0)) && <div className='row align-items-start g-2 '>
                    {(vehicleDetails?.length > 0) && <div className="col-sm-4">
                        <select name="vehicle_saved_id" id="vehicle_saved_id" value={vehicle_id} disabled={isVehicleVisible} className="form-select" {...register('vehicle_saved_id', { required: isVehicleVisible ? false : true })} onChange={handleVehicleSelectChange} >
                            <option value=''>Select Vehicle</option>
                            {vehicleDetails?.map((item, index) => {
                                return (
                                    <option value={item?.id} key={'Vehicle_' + index} selected={item.is_default == '1' ? true : false}>{item?.license_plate_number}</option>
                                )
                            })}
                        </select>
                        {/* {(vehicleList) && <span className="form-text text-danger h-40">{(vehicle_id == '' || !vehicle_id) && 'This field is required'}</span>} */}
                        {((errors?.vehicle_saved_id?.type === 'required') && (!isVehicleVisible) && vehicleList) && <span className="form-text text-danger h-40">This field is required</span>}
                    </div>}
                    {canAddVehicle && (
                        <div className={`col-${!isVehicleVisible ? '12 col-md-6 col-sm-8' : 'sm-6'}`}>
                            {vehicleDetails?.length > 0 && (
                                <span className='badge badge-primary text-dark fw-bold me-2'>OR</span>
                            )}
                            <button
                                className={`btn ${!isVehicleVisible ? 'btn-primary' : 'btn-danger'}`}
                                type="button"
                                onClick={isVehicleVisible ? hideVehicleForm : showVehicleForm}
                            >
                                <i className='fa fa-plus'></i> {!isVehicleVisible ? 'Add New Vehicle' : 'Select Existing Vehicle'}
                            </button>
                        </div>
                    )}
                </div>}
                {(vehicleDetails?.length < 1 || isVehicleVisible) && <div className='p-2 my-2 border'> <div className='row g-2 align-items-start'>
                    <div className="col-6 col-sm">
                        <label className='fw-bold mb-1'>License Plate <span style={{ color: 'red' }}>*</span></label>

                        <input type="text"
                            className="form-control"
                            name='license_plate'
                            value={makeModelObj.license_plate ? makeModelObj.license_plate : ''}
                            id="license_plate"
                            maxLength={10}
                            placeholder="License plate"
                            {...register('license_plate', {
                                required: { value: true, message: 'This field is required' },
                                minLength: { value: 2, message: 'Minimum 2 characters allowed' },
                            })}
                            onChange={handleInputFieldsData}

                        />

                        {((errors?.license_plate?.type === 'required') && (makeModelObj.license_plate.length == 0)) && <span className="form-text text-danger h-40">This field is required</span>}
                        {((errors?.license_plate?.type === 'minLength') && (makeModelObj.license_plate.length < 1)) && <span className="form-text text-danger h-40">{errors?.license_plate?.message}</span>}

                    </div>

                    <div className="col-6 col-sm">
                        <label className='fw-bold mb-1'>Vehicle Make</label>
                        <select autoComplete="off" name="make" placeholder="Make" className="form-select form-control" id="make" onChange={(e) => handleInputFieldsData(e)}>
                            <option value="">Select Make</option>
                            {(vehicleMakeList?.length > 0) && vehicleMakeList?.map((val, index) => {
                                return (
                                    <option value={val?.id} key={'make_' + index} >{val?.name}</option>
                                )
                            })}
                        </select>
                    </div>
                    {(makeModelObj.make === 'Others') && <div className="col-6 col-sm">
                        <label className='fw-bold mb-1'>Make</label>
                        <input type="text" className="form-control" name='make_other' id="make_other" placeholder="Enter Make" {...register('make_other')} onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e)} />
                    </div>}
                    {(makeModelObj.make !== 'Others') && <div className="col-6 col-sm">
                        <label className='fw-bold mb-1'>Vehicle Model</label>
                        <select autoComplete="off" name="model" value={makeModelObj?.model} placeholder="Model" disabled={makeModelObj.make === ''} className="form-select form-control" id="Model" onChange={(e) => handleInputFieldsData(e)}>
                            <option value="">Select Model</option>
                            {(vehicleListArray?.length > 0) && vehicleListArray?.map((val, index) => {
                                return (
                                    <option value={val?.name} key={'model_' + index} >{val?.name}</option>
                                )
                            })}
                        </select>
                    </div>}
                    {(makeModelObj.make === 'Others' || makeModelObj.model === 'Others') && <div className="col-6 col-sm">
                        <label className='fw-bold mb-1'>Model</label>
                        <input type="text" className="form-control" name='model_other' id="model_other" placeholder="Enter Model" {...register('model_other')} onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e)} />
                    </div>}
                    {/* vehicle type */}
                    {isPermissionExist(accessPermissions, 'Get Vehicle Type') ?
                        <Controller
                            name="vehicle_type"
                            control={control}
                            rules={{ required: 'This field is required' }}
                            render={({ field }) => (
                                <div className="col-6 col-sm">
                                    <label className='fw-bold mb-1'>Vehicle Type <span className='text-danger'>*</span></label>
                                    <select {...field} name='vehicle_type' autoComplete="off" className="form-select form-control" placeholder="vehicle_type" id='vehicle_type'
                                        onChange={(e) => {
                                            field.onChange(e) // update RHF
                                            handleInputFieldsData(e) // custom logic
                                        }}
                                        onKeyDown={restrictSpecialChar}
                                    >
                                        <option value="">Select an option</option>
                                        {(vehicleTypeData?.length > 0) && vehicleTypeData?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
                                    </select>
                                    {(errors?.vehicle_type?.type === 'required') && <span className="form-text text-danger h-40">This field is required</span>}
                                </div>
                            )}
                        />
                        : ''}

                    {/* vehicle type end */}
                    <div className="col-6 col-sm">
                        <label className='fw-bold mb-1'>Color</label>
                        <select autoComplete="off" name="color" placeholder="Model" className="form-select form-control" id="Model" onChange={(e) => handleInputFieldsData(e)}>
                            <option value="">Select an option</option>
                            {(colorList?.length > 0) && colorList?.map((val, index) => {
                                return (
                                    <option value={val?.name} key={'color_' + index} >{val?.name}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="col-6 col-sm">
                        <label className='fw-bold mb-1'>Country</label>
                        <select autoComplete="off" name='country' placeholder="Country" className="form-select form-control" id="country" onChange={(e) => handleInputFieldsData(e)}>
                            <option value="">Select an option</option>
                            {(countryList?.length > 0) && countryList?.map((val, index) => {
                                if (val.country_code == 'CA' || val.country_code == 'GB' || val.country_code == 'US') {
                                    return (
                                        <option value={val?.country_code} key={'country_' + index} >{val?.name}</option>
                                    )
                                } else {
                                    return ''
                                }
                            })}
                        </select>
                    </div>
                    <div className="col-6 col-sm">
                        <label className='fw-bold mb-1'>State/Province</label>
                        {makeModelObj.state_loader ? <div className="form-select form-control">
                            <Circles
                                height="20"
                                width="20"
                                color="#060D63"
                                ariaLabel="circles-loading"
                                visible={true}
                            />
                        </div> : <select autoComplete="off" name="state_id" value={makeModelObj.state_id} placeholder="Model" className="form-select form-control" id="Model" onChange={(e) => handleInputFieldsData(e)}>
                            <option value="">Select an option</option>
                            {(stateList?.length > 0) && stateList?.map((val, index) => {
                                return (
                                    <option value={val?.id} key={'state_' + index} >{val?.state_code}</option>
                                )
                            })}
                        </select>}
                    </div>
                </div></div>}
            </div>
            <div className="w-full mb-3">
                <label className="mb-1 "><b>Apply Coupon</b></label>
                <div className="row g-2">
                    <div className="col-sm-4">
                        <div className="input-group" id="couponBox">

                            {/* <CustomInput */}
                            <input
                                type="text"
                                name="coupon"
                                className="form-control"
                                placeholder="Enter Your Coupon Code"
                                aria-label="coupon"
                                aria-describedby="basic-addon1"
                                {...register('coupon', {
                                    onChange: (e) => { handleCoupon(e) }
                                })}
                            />
                            {sessionDetails?.promocode && !sessionError && <span className="cursor input-group-text" role='button' id="basic-addon1" onClick={handleCouponRemove}>X</span>}
                        </div>

                        <span className="promo-msg small "><span className="text-danger"></span></span>
                    </div>
                    <div className="col-auto">
                        <CommonBtn className="btn btn-primary" value='Apply' disabled={(bookingPromocode?.loader) ? true : false} onClick={applyCoupon} />
                    </div>

                    {bookingPromocode?.loader && <div className="col-auto align-self-center"><div className='d-flex justify-item-start align-items-center '><Loader width='24' height='24' /> &nbsp;&nbsp;Loading...</div></div>}



                </div>
                {!bookingShown?.couponError && sessionError?.message && <span className='small' style={{ color: 'red', width: '100%' }}>{sessionError?.message}</span>}
                {bookingShown?.couponError && <span className='small' style={{ color: 'red', width: '100%' }}>{bookingShown?.couponError}</span>}
                {sessionDetails?.promocode && !sessionError && !bookingShown?.couponError && <span className='small' style={{ color: 'green', width: '100%' }}>Coupon Code Applied Successfully!</span>}

            </div>
            <hr />
            {(sessionDetails?.data?.amount == 0 || (walletButtonShow && verifyPrepay == '1')) ? '' : <div className="w-full mb-3">
                <label className={`${!isUserLoggedIn() ? 'h5 mb-3' : 'mb-2'}`}><b>Payment Details {(isUserLoggedIn() && !isCardFormVisible) && <span style={{ color: 'red' }}>*</span>}</b></label>
                {(isUserLoggedIn() && (cardList?.length > 0)) && <div className={`${(cardList?.length < 1 || isCardFormVisible) ? 'mb-3 ' : ''}row row-cols-1 row-cols-sm-3 g-2`}>
                    {(cardList?.length > 0) && <div className="col">

                        <select name="vehicle" id="vehicle" disabled={isCardFormVisible} className="form-select" onChange={handleCardSelectChange} >
                            <option>Select Card</option>
                            {cardList?.map((card, index) => {
                                return (
                                    <option value={card?.payment_profile_id} selected={card?.payment_profile_id == payment_profile_id} key={index}>{`XXXX XXXX XXXX ${card?.card_last_four?.slice(0, 4)} (${card?.expiry?.slice(0, 2)}${card?.expiry?.slice(2, 4)})`}</option>
                                )
                            })}
                        </select>
                        {cardlidt && <span className="form-text text-danger h-40">{(payment_profile_id == '' || !payment_profile_id) ? 'Please select or add new card' : ''}</span>}
                        {/* {errors?.vehicle?.type === 'required' && <span className="form-text text-danger h-40" >Please select or add new card</span>} */}

                    </div>}

                    {(cardList?.length > 0) && !isCardFormVisible ? <div className='col'>{(cardList?.length > 0) && <span className='badge badge-primary text-dark fw-bold me-2'>OR</span>}
                        <button className='btn btn-primary' type="button" onClick={showCardForm}><i className='fa fa-plus'></i> Add New Card</button></div>
                        : (cardList?.length > 0) && <div className='col-sm-6'><span className='badge badge-primary text-dark fw-bold me-2'>OR</span>
                            <button className='btn btn-danger' type="button" onClick={hideCardForm}>Select Existing Card</button>
                        </div>}
                </div>}
                            
                {/* payment gate-way of booking event's */}
                {(cardList?.length < 1 || isCardFormVisible) && 
                (selectEventType == 'event' && checkInData?.facility_payment_details?.facility_payment_type_id != '3') || (selectEventType == 'pass' && eventandPassData?.facility?.facility_payment_details?.facility_payment_type_id != '3') ?
                <div className='row row-cols-1 row-cols-sm-3 g-2 align-items-start'>
                    <div className="col-sm-3 col-12">
                        <label className="mb-1 "><b>Card Number <span style={{ color: 'red' }}>*</span></b></label>
                        <Controller
                            name="card_pan"
                            type="text"
                            id="card_pan"
                            control={control}
                            inputmode="numeric"
                            rules={{
                                pattern: { value: /[0-9]*$/, message: 'Please enter a valid Card Number' },
                                required: { value: true, message: 'This field is required' },
                                minLength: { value: 14, message: 'Please enter a valid Card Number' },
                                maxLength: { value: 16, message: 'Please enter a valid Card Number' },
                            }}

                            render={({ field }) => <span className='cardNumberCardImage d-block'> <MaskedInput
                                maskGenerator={cardnumbermask}
                                autoComplete="off"
                                inputmode="numeric"
                                maxLength='19'
                                {...field}
                                id="card_pan"
                                className="form-control"
                                placeholder="Enter Card Number"
                            /></span>}
                        />
                        {errors?.card_pan && <>
                            {errors?.card_pan?.type === 'required' && <span className="form-text text-danger h-40">This field is required</span>}
                            {errors?.card_pan?.type === 'pattern' && <span className="form-text text-danger h-40">{errors?.card_pan?.message}</span>}
                            {errors?.card_pan?.type === 'minLength' && <span className="form-text text-danger h-40">{errors?.card_pan?.message}</span>}
                            {errors?.card_pan?.type === 'maxLength' && <span className="form-text text-danger h-40">{errors?.card_pan?.message}</span>}
                        </>}

                    </div>
                    <div className='col-sm-3 col-12'>
                        <label className="mb-1 "><b>Card Expiry <span style={{ color: 'red' }}>*</span></b></label>
                        <Controller
                            name="expiration_date"
                            type="number"
                            id="expiration_date"
                            inputmode="numeric"
                            control={control}
                            rules={{
                                required: { value: true, message: 'This field is required' },
                                minLength: { value: 4, message: 'Enter a valid expire date.' }
                            }}
                            render={({ field }) => <MaskedInput
                                maskGenerator={expirymask}
                                autoComplete="off"
                                inputmode="numeric"
                                maxLength='5'
                                id="expiration_date"
                                {...field}
                                onChange={(e) => { field.onChange(e); handlCardExpiry(e) }}
                                value={cardExpiry}
                                className="form-control"
                                placeholder="MM/YY"
                            />}
                        />
                        {errors?.expiration_date?.type === 'required' && <span className="form-text text-danger h-40" >This field is required</span>}
                        {errors?.expiration_date?.type === 'minLength' && <span className="form-text text-danger h-40" >{errors?.expiration_date?.message}</span>}
                        {<span className="form-text text-danger h-40">{cardExpiryMessage}</span>}

                    </div>
                    <div className="col-sm-3 col-12">
                        <label className="mb-1 "><b>Card CVV <span style={{ color: 'red' }}>*</span></b></label>
                        <div className="input-group">
                            <input
                                type={bookingShown.password ? 'text' : 'password'}
                                className="form-control"
                                id="card_card_security_cvx_2"
                                required
                                maxLength="4"
                                minLength="3"
                                inputMode="numeric"
                                name="card_card_security_cvx_2"
                                placeholder="CVV"
                                autoComplete="new-password"
                                {...register('card_card_security_cvx_2', {
                                    required: { value: true, message: 'This field is required' },
                                    pattern: { value: /^[0-9, a-z, A-Z ]{3,4}$/i, message: 'invalid CVV' }
                                })}
                            />
                            <span className="cursor input-group-text" role="button" id="basic-addon1" onClick={() => setbookingShown({ ...bookingShown, password: !bookingShown.password })}> <i className={bookingShown.password ? 'fas fa-eye-slash' : 'fas fa-eye'}></i></span>

                        </div>
                        <div style={{ width: '100%' }}>
                            {errors?.card_card_security_cvx_2?.type === 'required' && <span className="form-text text-danger h-40">This field is required</span>}
                            {errors?.card_card_security_cvx_2?.type === 'pattern' && <span className="form-text text-danger h-40">{errors?.card_card_security_cvx_2?.message}</span>}
                        </div>
                        <span className="text-danger cvvError mb-2"><b></b></span>
                    </div>

                    <div className="col-sm-3 col-12">
                        <label className="mb-1 "><b>Zipcode</b></label>
                        <div className="input-group">
                            <input
                                type={'text'}
                                className="form-control"
                                id="zipcode"
                                required
                                maxLength="6"
                                minLength="4"
                                inputMode="numeric"
                                name="zipcode"
                                placeholder="Zipcode"
                                pattern="[0-9]{5,6}"
                                onPaste={(e) => {
                                    e.preventDefault()
                                    return false
                                }}
                                onKeyPress={(e) => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? restrictSpecialChar(e) : restrictInputValues(e)}
                                autoComplete="new-password"
                                {...register('zipcode', {
                                    pattern: { value: /^[0-9, a-z, A-Z ]{5,6}$/i, message: 'Please enter a valid Zipcode' }
                                })}
                            />

                        </div>
                        <div style={{ width: '100%' }}>
                            {errors?.zipcode?.type == 'pattern' && <span className="form-text text-danger h-40">{errors?.zipcode?.message}</span>}
                        </div>
                        <span className="text-danger small">**Mandatory for Amex Cards only</span>
                    </div>



                    {(cardList?.length < 1 || isCardFormVisible) && (isUserLoggedIn()) && <div className="col">
                        <div className="form-check m-0">
                            <input className="form-check-input" name='user_consent' type="checkbox" value="" id="flexCheckDefault"  {...register('user_consent')} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Save the card
                            </label>
                        </div>

                    </div>}
                </div> : 
                // Display Fiserv Form
                (!isUserLoggedIn() || isCardFormVisible || cardList?.length < 1) ? <CardConnectTokenizer
                    setToken={setCardToken}
                    faciltyPaymentDetails={selectEventType == 'event' ? checkInData?.facility_payment_details : eventandPassData?.facility?.facility_payment_details}
                    setIframeErrorMessage={setIframeErrorMsg}
                    tokenRef={tokenRef}
                /> : null
                }
                {/* {cardDetailsError && <span style={{ color: 'red' }}>Please enter a valid card detail</span>} */}
                <input type='hidden' name='XXX_IPG_XXX' id='XXX_IPG_XXX' value='confirm' />
                <input type='hidden' name='XXX_IPGTRXNO_XXX' id='XXX_IPGTRXNO_XXX' value={sessionDetails?.data?.guid} />
                <input type='hidden' name='XXX_IPGSESSION_XXX' id='XXX_IPGSESSION_XXX' value={sessionDetails?.data?.ipgSession}></input>
            </div>}
            <div className='w-full mb-3'>
                <Button
                    variant="primary"
                    type="submit"
                    className="btn btn-danger btn-lg px-5"
                    onClick={handleSubmit(handleNextStep)}
                    disabled={isLoading || isSubmittingForm || localIsBookingClosed}
                >
                    <div className='d-flex justify-content-center align-items-center'>
                        <span>
                            {localIsBookingClosed
                                ? 'Sold Out'
                                : walletButtonShow && verifyPrepay === '1'
                                    ? 'Proceed to Pay'
                                    : 'Book'}
                        </span>
                        <span className='ms-2'>
                            {(isLoading || isSubmittingForm) ? (
                                <Circles
                                    height="20"
                                    width="20"
                                    style={{ display: 'inline-block' }}
                                    color="#ffffff"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                />
                            ) : null}
                        </span>
                    </div>
                </Button>
            </div>
            {(Number(sessionDetails?.data?.amount) > 0 && walletButtonShow && verifyPrepay == '0') ? <>
                <div className="my-3 fw-bold text-center">- OR -</div>

                <div className='d-flex justify-content-center'>
                    <div className='position-relative'>
                        {(walletDisable || isLoading) ? <div className='overlay-opacity'>&nbsp;</div> : null}
                        <WalletButtons
                            faciltyData={checkInData?.facility_payment_details?.id ? checkInData : eventandPassData?.facility?.facility_payment_details?.id ? eventandPassData?.facility : {}}
                            getValues={getValues} onSubmit={onClickSubmit} isSubmittingForm={isSubmittingForm}
                            setIsSubmittingForm={setIsSubmittingForm} setIsLoading={setIsSubmittingForm} payableAmount={sessionDetails?.data?.amount}
                            notify={notify} isIOSDevice={isIOSDevice} applePaySessionRef={applePaySessionRef}
                        />
                    </div>
                </div>
            </> : ''}
        </form>

    )
}

PaymentBookingPage.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    bookingFormPage: PropTypes.number,
    bookingFormDetail: PropTypes.object,
    nextFormStep: PropTypes.func,
    errors: PropTypes.object,
    control: PropTypes.func,
    register: PropTypes.func,
    handleSubmit: PropTypes.func,
    getValues: PropTypes.func,
    setValue: PropTypes.func,
    bookingPromocode: PropTypes.object,
    sessionDetails: PropTypes.object,
    sessionObj: PropTypes.object,
    sessionError: PropTypes.object,
    reset: PropTypes.func,
    userDetails: PropTypes.object,
    ExpiryTimeSession: PropTypes.number,
    eventandPassData: PropTypes.object,
    selectEventType: PropTypes.string,
    isLoading: PropTypes?.bool,
    isDirectBooking: PropTypes.bool,
    cardList: PropTypes.array,
    isCardFormVisible: PropTypes.bool,
    isVehicleVisible: PropTypes.bool,
    payment_profile_id: PropTypes.string,
    vehicle_id: PropTypes.string,
    selectedFacilityId: PropTypes.string,
    fname: PropTypes.string,
    femail: PropTypes.string,
    fphone: PropTypes.string,
    fcard_pan: PropTypes.string,
    fcard_date_expiry_month: PropTypes.string,
    fcard_card_security_cvx_2: PropTypes.string,
    expiration_date: PropTypes.string,
    vehicleDetails: PropTypes.array,
    cardToken: PropTypes.object,
    setCardToken: PropTypes.func,
    iframeErrorMsg: PropTypes.string,
    setIframeErrorMsg: PropTypes.func,
    tokenRef: PropTypes.object,
}

PaymentBookingPage.defaulProps = {
    dispatch: noop,
    notify: noop,
    bookingFormPage: 1,
    bookingFormDetail: EMPTY_OBJECT,
    nextFormStep: noop,
    errors: EMPTY_OBJECT,
    control: noop,
    register: noop,
    handleSubmit: noop,
    getValues: noop,
    setValue: noop,
    bookingPromocode: EMPTY_OBJECT,
    sessionDetails: EMPTY_OBJECT,
    sessionObj: EMPTY_OBJECT,
    sessionError: EMPTY_OBJECT,
    reset: noop,
    userDetails: EMPTY_OBJECT,
    ExpiryTimeSession: 0,
    eventandPassData: EMPTY_OBJECT,
    selectEventType: '',
    isLoading: false,
    isDirectBooking: false,
    cardList: EMPTY_ARRAY,
    isCardFormVisible: false,
    isVehicleVisible: false,
    payment_profile_id: '',
    vehicle_id: '',
    selectedFacilityId: '',
    fname: '',
    femail: '',
    fphone: '',
    fcard_pan: '',
    fcard_date_expiry_month: '',
    fcard_card_security_cvx_2: '',
    expiration_date: '',
    vehicleDetails: EMPTY_ARRAY,
    cardToken: EMPTY_OBJECT,
    setCardToken: noop,
    iframeErrorMsg: undefined,
    setIframeErrorMsg: noop,
    tokenRef: EMPTY_OBJECT,
}

function mapStateToProps({ globalReducers, bookingReducer, loginReducer }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        bookingFormPage: globalReducers?.bookingFormPage,
        bookingFormDetail: globalReducers?.bookingFormDetail,
        bookingPromocode: bookingReducer,
        sessionDetails: globalReducers?.sessionDetails,
        sessionError: globalReducers?.sessionError,
        userDetails: (Object.keys(globalReducers?.userDetails || {}).length > 0) ? globalReducers?.userDetails : loginReducer?.data?.data?.user,
        ExpiryTimeSession: globalReducers?.ExpiryTimeSession,
        eventandPassData: (globalReducers?.selectEventType == 'pass') ? globalReducers?.passData : globalReducers?.eventData?.[0],
        selectEventType: globalReducers?.selectEventType,
        isLoading: bookingReducer?.loader,
        couponFilled: bookingReducer?.data?.couponFilled,
        coupon_code: bookingReducer?.data?.coupon,
        couponApplied: bookingReducer?.data?.coupon,
        isDirectBooking: globalReducers?.isDirectBooking,
        cardList: (bookingReducer?.cardDetails?.length) ? bookingReducer?.cardDetails : EMPTY_ARRAY,
        payment_profile_id: globalReducers?.payment_profile_id,
        vehicle_id: globalReducers?.vehicle_id,
        isCardFormVisible: (globalReducers?.isCardFormVisible) ? globalReducers?.isCardFormVisible : '',
        isVehicleVisible: (globalReducers?.isVehicleVisible) ? globalReducers?.isVehicleVisible : '',
        selectedFacilityId: globalReducers?.selectedFacilityId,
        vehicleDetails: (bookingReducer?.vehicleDetails?.length) ? bookingReducer?.vehicleDetails : EMPTY_ARRAY,
    }
}

export default connect(mapStateToProps)(PaymentBookingPage)